import { NgModule } from '@angular/core'
import { AsmComponentsModule } from '@spartacus/asm/components'
import { CartPageEventModule } from '@spartacus/cart/base/core'
import {
  AnonymousConsentsModule,
  AuthConfig,
  AuthModule,
  CostCenterModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideConfig,
  provideFeatureToggles,
  UserModule,
  UserOccModule
} from '@spartacus/core'
import {
  OrderCancellationModule,
  OrderDetailsModule,
  OrderHistoryModule,
  OrderReturnModule,
  ReplenishmentOrderDetailsModule,
  ReplenishmentOrderHistoryModule,
  ReturnRequestDetailModule,
  ReturnRequestListModule
} from '@spartacus/order/components'
import { ProductVariantsModule } from '@spartacus/product/variants'
import { QualtricsComponentsModule } from '@spartacus/qualtrics/components'
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  PageTitleModule,
  PaymentMethodsModule,
  ProductDetailsPageModule,
  ProductImagesModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductTabsModule,
  ScrollToTopModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule
} from '@spartacus/storefront'
import { AddressBookModule, UpdateEmailModule } from '@spartacus/user/profile/components'
import { ContactUsModule } from '../features/contact-us/contact-us.module'
import { CustomProductTabModule } from '../features/custom-product-tab/custom-product-tab.module'
import { CustomFooterNavigationModule } from '../features/navigation/custom-footer-navigation/custom-footer-navigation.module'
import { CustomNotificationPreferenceModule } from '../features/notification-preference/custom-notification-preference.module'
import { CustomProductCarouselModule } from '../features/product/carousel/custom-product-carousel/custom-product-carousel.module'
import { CustomProductReferencesModule } from '../features/product/carousel/custom-product-references/custom-product-references.module'
import { CompareProductsModule } from '../features/product/compare-products/compare-products.module'
import { CustomProductIntroModule } from '../features/product/custom-product-intro/custom-product-intro.module'
import { CustomProductFacetNavigationModule } from '../features/product/custom-product-list/custom-product-facet-navigation/custom-product-facet-navigaton.module'
import { CustomProductListModule } from '../features/product/custom-product-list/custom-product-list.module'
import { CustomProductReplacementModule } from '../features/product/custom-product-replacement/custom-product-replacement.module'
import { CustomProductSummaryModule } from '../features/product/custom-product-summary/custom-product-summary.module'
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module'
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module'
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module'
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module'
import { WishListFeatureModule } from './features/cart/wish-list-feature.module'
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module'
import { OrderFeatureModule } from './features/order/order-feature.module'
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module'
import { UserFeatureModule } from './features/user/user-feature.module'

@NgModule({
  declarations: [],
  imports: [
    // Standard OOTB Modules
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    UserModule,
    UserOccModule,
    AddressBookModule,
    PaymentMethodsModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    SearchBoxModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    CustomFooterNavigationModule,
    ContactUsModule,
    ExternalRoutesModule.forRoot(),

    //Products
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    CustomProductFacetNavigationModule,
    ProductPageEventModule,
    ProductTabsModule,
    ProductImagesModule,
    CustomProductIntroModule,
    CustomProductSummaryModule,
    CustomProductReplacementModule,
    CustomProductReferencesModule,
    CustomProductCarouselModule,
    CustomProductListModule,
    CompareProductsModule,
    CustomProductTabModule,

    // User UI
    CustomNotificationPreferenceModule,

    // Modules that are under ~/spartacus/features ...
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CheckoutFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    SmartEditFeatureModule,

    // TODO: Validate & Verify the usage of these modules
    OrderHistoryModule,
    OrderDetailsModule,
    OrderCancellationModule,
    OrderReturnModule,
    ReturnRequestListModule,
    ReturnRequestDetailModule,
    ReplenishmentOrderHistoryModule,
    ReplenishmentOrderDetailsModule,
    CartPageEventModule,
    CostCenterModule.forRoot(),
    AsmComponentsModule,
    QualtricsComponentsModule,
    ProductVariantsModule,
    UpdateEmailModule
  ],
  providers: [
    provideFeatureToggles({
      authorizationCodeFlowByDefault: true,
      asyncAuthConfigInitializer: true,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      cdsLoginEventsToken: true
    }),
    provideConfig(<AuthConfig>{
      authentication: {
        customLoginPage: undefined,
        initializerOptions: {
          addBaseSiteToRedirectUri: true,
          baseSiteSuffix: true
        }
      }
    })
  ]
})
export class SpartacusFeaturesModule {}
